import { useEffect } from 'react';

let lockCount = 0;
let savedOverflow = '';
let savedPaddingRight = '';

function scrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

function acquireBodyScrollLock() {
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    savedPaddingRight = document.body.style.paddingRight;
    const width = scrollbarWidth();
    document.body.style.setProperty('--scrollbar-width', `${Math.max(width, 0)}px`);
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = width > 0 ? `${width}px` : savedPaddingRight;
    document.body.dataset.scrollLocked = 'true';
  }
  lockCount += 1;
}

function releaseBodyScrollLock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow;
    document.body.style.paddingRight = savedPaddingRight;
    document.body.style.removeProperty('--scrollbar-width');
    delete document.body.dataset.scrollLocked;
  }
}

/**
 * Prevents body scrolling while a modal/overlay is mounted. Reference-counted so
 * nested overlays cannot accidentally unlock the background page too early.
 */
export function useBodyScrollLock(active: boolean = true) {
  useEffect(() => {
    if (!active) return;
    acquireBodyScrollLock();
    return releaseBodyScrollLock;
  }, [active]);
}

/**
 * Prevents background body scrolling — always active while component is mounted.
 */
export default function BodyScrollLock() {
  useBodyScrollLock(true);
  return null;
}
